import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PatentDescApi } from '../patent-desc-api';
import { PsHttpService, type PatSnapSuccessResponseData } from '@patsnap/tahiti-core';
import { coreTelecomApiUrlPrefix } from '@telecom/shared/domain-config';
import type { PatentImageApi, PatentOfficeImagesResponse } from '../patent-image-api';
import type { IDbConfigResponse, PatentDbApi } from '../patent-db-api';
import { CORE_BASIC_SERVICE_URI } from '@telecom/shared/domain-config/config';
import { PatentClaimApi, type PatentClaimsTreeResponse } from '../patent-claim-api';
import { PatentLegalStatusApi } from '../patent-legal-status-api';

@injectable()
export class PatentApiImpl extends PsHttpService
    implements PatentDescApi, PatentImageApi, PatentDbApi, PatentClaimApi, PatentLegalStatusApi
{
    get options() {
        return {
            baseURL: coreTelecomApiUrlPrefix,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }
    /**
     * 获取专利描述
     */
    async getPatentDesc(payload: {patentId: string ,lang: string}) {
        const res = await this.get<PatSnapSuccessResponseData<string>>({
            url: `patent/${payload.patentId}/desc`,
            params: {
                lang: payload.lang,
            },
            cache: true,
        });
        return res.data;
    }

    /**
     * 获取专利权利要求
     */
    async getPatentClaim(payload: {patentId: string ,lang: string}): Promise<string> {
        const res = await this.get<PatSnapSuccessResponseData<string>>({
            url: `patent/${payload.patentId}/claim`,
            params: {
                lang: payload.lang,
            },
            cache: true,
        });
        return res.data;
    }

    async getPatentClaimsTree(patentId: string) {
        const res = await this.get<PatSnapSuccessResponseData<PatentClaimsTreeResponse>>({
            url: `patent/${patentId}/clms-tree`,
            cache: true,
        });

        return res.data;
    }

    /**
     * 获取专利图片
     */
    async getPatentOfficeImage(payload: {patentId: string}) {
        const res = await this.get<PatSnapSuccessResponseData<Record<string, PatentOfficeImagesResponse>>>({
            url: `patent/${payload.patentId}/official-image`,
            cache: true,
        });
        return res.data?.[payload.patentId];
    }
    /**
     * 获取专利数据库配置
     */
    async getDbConfig() {
        const res = await this.get<PatSnapSuccessResponseData<IDbConfigResponse>>({
            baseURL: CORE_BASIC_SERVICE_URI,
            url: '/core-basic-api/analytics/db-select/config',
            cache: true,
        });
        return res.data;
    }
    /**
     * 获取专利法律状态
     */
    async getPatentLegalStatus() {
        const res = await this.get<PatSnapSuccessResponseData<any>>({
            baseURL: CORE_BASIC_SERVICE_URI,
            url: '/core-basic-api/analytics/config/legal-status',
            cache: true,
        });
        return res.data;
    }
}
